export enum MeetingParticipantsType {
    SellerBuyer = 1,
    SellerAdvisor = 2,
    SellerAdminSupport = 3,
    BuyerAdminSupport = 4,
    AdvisorAdminSupport = 5,
    BuyerAdvisor = 6,
}

export const MeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerBuyer]: 'Seller / Buyer',
    [MeetingParticipantsType.SellerAdvisor]: 'Seller / Advisor',
    [MeetingParticipantsType.SellerAdminSupport]: 'Seller / Admin Support',
    [MeetingParticipantsType.BuyerAdminSupport]: 'Buyer / Admin Support',
    [MeetingParticipantsType.AdvisorAdminSupport]: 'Advisor / Admin Support',
    [MeetingParticipantsType.BuyerAdvisor]: 'Buyer / Advisor',
};

export const AdminMeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerAdminSupport]: 'Seller / Admin Support',
    [MeetingParticipantsType.BuyerAdminSupport]: 'Buyer / Admin Support',
    [MeetingParticipantsType.AdvisorAdminSupport]: 'Advisor / Admin Support',
};

export const BrokerMeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerAdvisor]: 'Seller / Advisor',
    [MeetingParticipantsType.BuyerAdvisor]: 'Buyer / Advisor',
};

export const EngagementMeetingTypeHeaderColor = {
    [MeetingParticipantsType.SellerBuyer]: '#fb9191',
    [MeetingParticipantsType.SellerAdvisor]: '#fb9191',
    [MeetingParticipantsType.SellerAdminSupport]: '#fb9191',
    [MeetingParticipantsType.BuyerAdminSupport]: '#fb9191',
    [MeetingParticipantsType.AdvisorAdminSupport]: '#fb9191',
    [MeetingParticipantsType.BuyerAdvisor]: '#fb9191',
} as const;

export const EngagementMeetingTypeBodyColor = {
    [MeetingParticipantsType.SellerBuyer]: '#fff3f3',
    [MeetingParticipantsType.SellerAdvisor]: '#fff3f3',
    [MeetingParticipantsType.SellerAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.BuyerAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.AdvisorAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.BuyerAdvisor]: '#fff3f3',
} as const;